export default "__VITE_ASSET__HqHRFuWS__"